export const LICENCE_TYPES = ["TFL", "Castlepoint", "Hertsmere"];
